import { ReactElement } from 'react';

import { Box, Grid, styled } from '@mui/material';
import { FormProvider } from 'react-hook-form';

import MeetingAgendaPreview from '../components/form/MeetingAgendaPreview';
import MeetingCategory from '../components/form/MeetingCategory';
import MeetingName from '../components/form/MeetingName';
import MeetingTemplate from '../components/form/MeetingTemplate';
import MeetingHeaders from '../components/utils/MeetingHeaders';
import { useMeetingTemplateForm } from '../hooks/use-meeting-template-form';
import { useGetTemplateAction } from '../store';

const StyledContainer = styled(Box)({
  borderRadius: '8px',
  overflow: 'auto',
  padding: '2rem',
  height: 'auto',
  backgroundColor: '#fff',
  boxShadow: '0px 2px 8px 0px rgba(78, 80, 84, 0.16)',
});

export const ActionMeetingTemplateEditor = (): ReactElement => {
  const form = useMeetingTemplateForm();
  const templateAction = useGetTemplateAction();
  return (
    <StyledContainer>
      <FormProvider {...form}>
        <MeetingHeaders />
        <Grid container spacing={2}>
          {templateAction !== 'Create' && (
            <Grid item xs={12}>
              <MeetingTemplate />
            </Grid>
          )}
          <Grid item xs={12}>
            <MeetingName />
          </Grid>
          <Grid item xs={12}>
            <MeetingCategory />
          </Grid>
          <Grid item xs={12}>
            <MeetingAgendaPreview />
          </Grid>
        </Grid>
      </FormProvider>
    </StyledContainer>
  );
};
